import '../../Agora 4.0/IdcGlobal.Agora.JavaScript.PlugIn/AreaMap.css'
import '../../Agora 4.0/IdcGlobal.Agora.JavaScript.PlugIn/AreaMap.js'